import style from "../style/layout.module.css";
import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Colors,
} from "chart.js";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { Radar } from "react-chartjs-2";
import { useRecoilState } from "recoil";
import { AtomScore } from "../store/store";
import { useParams } from "react-router-dom";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Colors
);

export default function ShareIdeal({ ability }) {
  const params = useParams();
  console.log(params);
  const LIMIT_POINT = 20;

  const ideal = [
    { name: "키", title: "height", value: ability.height },
    { name: "직업", title: "job", value: ability.job },
    { name: "학력", title: "degree", value: ability.degree },
    { name: "집안", title: "family", value: ability.family },
    { name: "경제력", title: "economy", value: ability.economy },
  ];

  const data = {
    labels: ideal.map((list) => list.name),
    datasets: [
      {
        label: "나의 이상형은?",
        data: Object.values(ability)?.map((value) => Number(value)),
        backgroundColor: ({ chart: { ctx } }) => {
          const bg = ctx.createLinearGradient(0, 150, 0, 400);
          bg.addColorStop(0, "#e08a50a6");
          bg.addColorStop(1, "#e7bd8a62");
          return bg;
        },
        borderColor: "transparent",
        borderWidth: 0,
        color: "red",
      },
    ],
  };
  useEffect(() => {}, []);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        pointLabels: {
          font: {
            size: 16, // 폰트 크기 설정
          },
        },
        min: 0,
        max: 10,
        ticks: {
          stepSize: 1,
          color: "transparen",
          backdropColor: "transparent",
        },
      },
    },
  };
  const totalPoint = Object.values(ability)
    .map((li) => Number(li.value))
    .reduce((a, b) => {
      return a + b;
    });

  return (
    <div className={style.ideal}>
      <h4 className={style.ideal_title}>선호 이상형 등급기준</h4>
      <div
        style={{
          position: "relative",
          width: "99%",
          height: "auto",
          aspectRatio: "1/1",
        }}
      >
        <Radar data={data} options={options} />
      </div>
      {ideal.map((list, i) => (
        <TextInput
          key={list.title}
          title={list.title}
          name={list.name}
          value={list.value}
          limit={LIMIT_POINT}
          totalPoint={totalPoint}
        />
      ))}
    </div>
  );
}

const TextInput = ({ title, name, value, limit, totalPoint }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        marginBottom: "10px",
        height: "19px",
      }}
    >
      <span style={{ width: 50, fontSize: 18 }}>{name}</span>

      <progress value={value} max={10}></progress>

      <p style={{ marginTop: -2, width: 17, fontSize: 18 }}>{value}</p>
    </div>
  );
};
